import FilterObject from '../shared/Filter/FilterObject';
import moment from 'moment';

class RidershipFilterObject extends FilterObject {
  filter(availableMembers, startTime) {
    return super.filter(availableMembers, { startTime: startTime });
  }

  satisfiesConditions(member, options) {
    return super.satisfiesConditions(member) && this.isAvailableAt(member, options.startTime);
  }

  // As requested by Buckinghamshire, the fiter must return members available exactly
  // at the timestamp.
  isAvailableAt = (member, startTime) => {
    return moment(startTime).isBetween(moment(member.startTime), moment(member.endTime), null, '[)');
  };
}

export default RidershipFilterObject;
